<template>
<v-container class="pt-4 pb-12 py-sm-12">

    <!-- Header -->
    <v-row class="mb-4">
      <v-col cols="12">
        <div class="d-flex justify-space-between align-center">
          <div class="title-block">
    <span id="title" class="page-title">Parâmetros</span>
    <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
        {
            text: 'Homepage',
            disabled: false,
            to: '/home',
            exact: true,
        },
        {
            text: 'Parâmetros',
            disabled: true,
            exact: true,
        },
    ]"></v-breadcrumbs>
</div>
      <v-btn color="primary" dark class="btn-salvar" @click="abrirConfirmacao">
    Salvar
</v-btn>
        </div>
      </v-col>
    </v-row>

    <v-form ref="form" v-model="dataForm.validForm">

      <!-- CARD: INFORMAÇÕES DA EMPRESA -->
      <v-card class="card-section mb-4" elevation="0">
        <v-card-title class="section-title">
          <v-icon left color="primary" small>mdi-store</v-icon>
          Informações da Empresa
        </v-card-title>
        <v-divider class="mx-4 mb-4" />
        <v-card-text class="pt-0">
          <v-row dense>
            <v-col cols="12" sm="6">
              <div class="info-label">Nome</div>
              <div class="info-value">{{ operacao.nome || '—' }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="info-label">Cidade</div>
              <div class="info-value">{{ operacao.cidade || '—' }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="info-label">Endereço</div>
              <div class="info-value">{{ operacao.endereco || '—' }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="info-label">Complemento</div>
              <div class="info-value">{{ operacao.complemento || '—' }}</div>
            </v-col>
            <v-col cols="12" class="mt-2">
              <v-checkbox
                v-model="operacao.aceitaPix"
                label="Aceitar pagamento via PIX"
                color="primary"
                dense
                hide-details
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

          
             <!-- CARD: STATUS DAS MÁQUINAS -->
      <!--
      <v-card class="card-section mb-4" elevation="0">
        <v-card-title class="section-title">
          <v-icon left color="primary" small>mdi-washing-machine</v-icon>
          Status das Máquinas
        </v-card-title>
        <v-divider class="mx-4 mb-4" />
        <v-card-text class="pt-0">
          <div class="info-label mb-2" style="text-transform: none; font-size: 13px; color: #666; font-weight: 400;">
            Compartilhe este link com seus clientes para que acompanhem a disponibilidade das máquinas.
          </div>

                         <div v-if="operacao.operationCode" class="d-flex align-center" style="gap: 10px;">
            <span class="link-status-maquinas">
              {{ $vuetify.breakpoint.mdAndUp ? urlStatusMaquinas : urlStatusMaquinasResumida }}
            </span>
            <v-btn color="primary" dark @click="copiarUrlStatus">
              <v-icon v-if="$vuetify.breakpoint.mdAndUp" left small>mdi-content-copy</v-icon>
              <v-icon v-else small>mdi-content-copy</v-icon>
              <span v-if="$vuetify.breakpoint.mdAndUp">Copiar</span>
            </v-btn>
          </div>

          <v-btn v-else color="primary" outlined :loading="gerandoLink" @click="gerarLink">
            <v-icon left small>mdi-link-variant</v-icon>
            Gerar link
          </v-btn>
        </v-card-text>
      </v-card>
          -->

      <!-- CARD: LOGO DA LAVANDERIA -->
      <v-card class="card-section mb-4" elevation="0">
        <v-card-title class="section-title">
          <v-icon left color="primary" small>mdi-image</v-icon>
          Logo da Lavanderia
        </v-card-title>
        <v-divider class="mx-4 mb-4" />
        <v-card-text class="pt-0">

          <!-- Instruções visíveis -->
          <div class="instrucoes-box mb-4">
            <div class="instrucao-item">✔ Tamanho máximo: <strong>500KB</strong></div>
            <div class="instrucao-item">✔ Formato aceito: <strong>PNG com fundo transparente</strong></div>
            <div class="instrucao-item">✔ Dimensões mínimas: <strong>640 x 480 pixels</strong></div>
            <div class="instrucao-item">✔ Dimensões máximas: <strong>1600 x 1084 pixels</strong></div>
          </div>

          <v-row align="center">
            <!-- Preview -->
            <v-col cols="12" sm="4" class="d-flex justify-center">
              <div class="logo-preview-area">
                <v-img
                  v-if="previewLogo"
                  :src="previewLogo"
                  contain
                  class="logo-preview-img"
                />
                <div v-else class="logo-placeholder">
                  <v-icon size="48" color="#ccc">mdi-image-off-outline</v-icon>
                  <div style="font-size:12px; color:#aaa; margin-top:6px;">Sem logo</div>
                </div>
              </div>
            </v-col>

            <!-- Ações -->
<v-col cols="12" sm="8" class="d-flex flex-column align-center align-sm-start">
  <v-file-input
    ref="logoInput"
    v-model="logoFile"
    accept="image/png"
    dense
    hide-details
    prepend-icon=""
    style="display:none"
    @change="verificarImagem"
  />

  <div class="d-flex flex-column" style="gap:10px; width:100%; max-width:240px;">
    <v-btn
      color="primary"
      outlined
      small
      block
      @click="abrirSeletorImagem"
    >
      <v-icon left small>mdi-upload</v-icon>
      Escolher imagem
    </v-btn>

    <v-btn
      v-if="logoFileValido"
      color="success"
      small
      block
      @click="enviarLogo"
    >
      <v-icon left small>mdi-check</v-icon>
      Enviar logo
    </v-btn>

   <v-btn
    v-if="previewLogo && !logoFileValido"
    small
    block
    elevation="0"
    style="background-color: #FF3636 !important; color: white !important;"
    @click="excluirLogo"
>
    <v-icon left small>mdi-delete</v-icon>
    Excluir logo
</v-btn>
  </div>

  <div v-if="erroImagem" class="error-text mt-2">
    <v-icon small color="error">mdi-alert-circle</v-icon>
    {{ erroImagem }}
  </div>
</v-col>
          </v-row>

        </v-card-text>
      </v-card>

      <!-- CARD: CADASTRO DE USUÁRIO -->
      <v-card class="card-section mb-4" elevation="0">
        <v-card-title class="section-title">
          <v-icon left color="primary" small>mdi-account-plus</v-icon>
          Cadastro de Usuário
        </v-card-title>
        <v-divider class="mx-4 mb-4" />
        <v-card-text class="pt-0">
          <v-switch
            v-model="operacao.possuiCadastro"
            label="Habilitar cadastro de clientes"
            color="primary"
            dense
            hide-details
            class="mb-3"
          />

          <div v-if="operacao.possuiCadastro">
            <div class="info-label mb-2">Tipo de cadastro</div>
            <v-radio-group
              v-model="operacao.tipoCadastro"
              row
              dense
              hide-details
            >
              <v-radio label="Opcional" value="OPCIONAL" color="primary" />
              <v-radio label="Obrigatório" value="OBRIGATORIO" color="primary" />
            </v-radio-group>
          </div>
        </v-card-text>
      </v-card>

    </v-form>

    <!-- DIALOG CONFIRMAÇÃO -->
    <v-dialog v-model="dialogConfirmar" max-width="400">
  <v-card>
    <v-card-title>Atualizar Parâmetros</v-card-title>
    <v-card-text>Deseja salvar as alterações?</v-card-text>
    <v-card-actions class="justify-end">
      <v-btn text @click="dialogConfirmar = false">Cancelar</v-btn>
      <v-btn text @click="salvar">Salvar</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      timeout="3000"
      top
      right
    >
      {{ snackbar.text }}
    </v-snackbar>

  </v-container>
</template>

<script>
import axios from "@/plugins/axios";
import { eventHub } from "@/main";

export default {
  name: "ParametrosList",

data() {
  return {
       operacao: {
      id: null,
      nome: "",
      cpfCnpj: "",
      endereco: "",
      complemento: "",
      cidade: "",
      uf: "",                 
      aceitaPix: false,
      possuiCadastro: false,
      tipoCadastro: "OPCIONAL",
      recebedorPixId: null,
      logo: null,  
      usuario: null,
      operationCode: null           
    },

    logoFile: null,
    logoFileValido: null,
    previewLogo: null,
    erroImagem: "",

       dataForm: { validForm: true },
    dialogConfirmar: false,
    gerandoLink: false,

    snackbar: {
      show: false,
      text: "",
      color: "success"
    }
  };
},

 mounted() {
  this.carregarOperacao();

  var self = this;
  eventHub.$on('CHANGE-OPERATION', function() {
    self.carregarOperacao();
  });
},

destroyed() {
  eventHub.$off('CHANGE-OPERATION');
},

    computed: {
       urlStatusMaquinas() {
      return this.operacao.urlStatusMaquina || "";
    },
    urlStatusMaquinasResumida() {
      // Versão enxuta pra mobile: mantém a URL completa intacta pro clipboard,
      // só exibe o caminho final (status-maquina?operationCode=XXXX).
      if (!this.urlStatusMaquinas) return "";
      const partes = this.urlStatusMaquinas.split("/");
      return partes.slice(-1)[0].startsWith("status-maquina")
        ? partes.slice(-1)[0]
        : this.urlStatusMaquinas;
    }
  },

  methods: {
    copiarUrlStatus() {
      if (!this.urlStatusMaquinas) return;
      navigator.clipboard.writeText(this.urlStatusMaquinas);
      this.mostrarSnackbar("Link copiado com sucesso!");
    },

    async gerarLink() {
      if (!this.operacao.id) return;
      this.gerandoLink = true;
      try {
        const res = await axios.post(`/api/operacao/${this.operacao.id}/gerar-link`);
        this.operacao.operationCode = res.data.operationCode;
        this.operacao.urlStatusMaquina = res.data.urlStatusMaquina;
        this.mostrarSnackbar("Link gerado com sucesso!");
      } catch (e) {
        console.error("Erro ao gerar link:", e);
        this.mostrarSnackbar("Erro ao gerar link", "error");
      } finally {
        this.gerandoLink = false;
      }
    },

    async carregarOperacao() {
  try {
    const operacaoId = localStorage.getItem("operation");

    if (!operacaoId) {
      this.mostrarSnackbar("Nenhuma operação selecionada", "error");
      return;
    }

    const res = await axios.get(`/api/operacao/${operacaoId}`);
    const op = res.data;

    this.operacao = {
      ...this.operacao,
      ...op,
      usuario: op.usuario || null,   
      nome: op.nome || "",
      endereco: op.endereco || "",
      uf: op.uf || "RS",
      aceitaPix: !!op.aceitaPix,
      possuiCadastro: !!op.possuiCadastro
    };

    this.previewLogo = op.logoUrl || null;

  } catch (e) {
    console.error("Erro ao carregar:", e);
    this.mostrarSnackbar("Erro ao carregar dados", "error");
  }
},
async atualizarOperacao() {
  try {
 const payload = {
  nome: this.operacao.nome,
  cpfCnpj: this.operacao.cpfCnpj,
  endereco: this.operacao.endereco,
  complemento: this.operacao.complemento,
  cidade: this.operacao.cidade,
  uf: this.operacao.uf,
  possuiCadastro: !!this.operacao.possuiCadastro,
  aceitaPix: !!this.operacao.aceitaPix,
  recebedorPixId: this.operacao.recebedorPixId,
  tipoCadastro: this.operacao.tipoCadastro || 'OPCIONAL',
  usuarioId: this.operacao.usuario ? this.operacao.usuario.id : null
};

    await axios.put(`/api/operacao/${this.operacao.id}`, payload);
    this.mostrarSnackbar("Dados salvos com sucesso!");
    this.logoFile = null;
    this.logoFileValido = null;
    this.carregarOperacao();
 } catch (e) {
  console.error("Erro ao salvar:", e);
  let msg = "Erro ao salvar dados";
  if (e.response && e.response.data && e.response.data.mensagem) {
    msg = e.response.data.mensagem;
  }
  this.mostrarSnackbar(msg, "error"); // ← linha que estava faltando
}
},

async enviarLogo() {
  if (!this.logoFileValido) return;

  try {
    const formData = new FormData();
    formData.append("file", this.logoFileValido);

    await axios.post(`/api/operacao/${this.operacao.id}/logo`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    this.mostrarSnackbar("Logo enviado com sucesso!");
    this.logoFile = null;
    this.logoFileValido = null;
    this.carregarOperacao();
  } catch (e) {
    console.error("Erro ao enviar logo:", e);
    this.mostrarSnackbar("Erro ao enviar logo", "error");
  }
},
    async excluirLogo() {
      try {
        await axios.delete(`/api/operacao/${this.operacao.id}/logo`);
        this.previewLogo = null;
        this.operacao.logo = null;
        this.mostrarSnackbar("Logo excluído com sucesso!");
      } catch (e) {
        console.error("Erro ao excluir logo:", e);
        this.mostrarSnackbar("Erro ao excluir logo", "error");
      }
    },

    abrirSeletorImagem() {
      const input = this.$refs.logoInput.$el.querySelector("input");
      if (input) input.click();
    },

  verificarImagem(file) {
  this.erroImagem = "";
  this.logoFileValido = null;
  if (!file) return;

  if (file.size > 500 * 1024) {
    this.erroImagem = "A imagem deve ter no máximo 500KB.";
    return;
  }

  const img = new Image();
  const objectUrl = URL.createObjectURL(file);

  img.onload = () => {
    if (img.width < 640 || img.height < 480) {
      this.erroImagem = "A imagem deve ter no mínimo 640x480 pixels.";
      URL.revokeObjectURL(objectUrl);
      return;
    }
    if (img.width > 1600 || img.height > 1084) {
      this.erroImagem = "A imagem deve ter no máximo 1600x1084 pixels.";
      URL.revokeObjectURL(objectUrl);
      return;
    }

    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);

    // Verifica amostra de pontos nas bordas e centro
    const pontos = [
      [0, 0],
      [img.width - 1, 0],
      [0, img.height - 1],
      [img.width - 1, img.height - 1],
      [Math.floor(img.width / 2), Math.floor(img.height / 2)]
    ];

    const temTransparencia = pontos.some(function(p) {
      return ctx.getImageData(p[0], p[1], 1, 1).data[3] < 255;
    });

    if (!temTransparencia) {
      this.erroImagem = "A imagem deve ter fundo transparente (PNG com transparência).";
      URL.revokeObjectURL(objectUrl);
      return;
    }

    this.previewLogo = objectUrl;
    this.logoFileValido = file;
  };

  img.src = objectUrl;
},

    abrirConfirmacao() {
      if (this.$refs.form.validate()) {
        this.dialogConfirmar = true;
      }
    },

    salvar() {
      this.dialogConfirmar = false;

      if (!this.operacao.id) {
        this.mostrarSnackbar("ID da operação não encontrado", "error");
        return;
      }

      if (this.logoFileValido) {
        const reader = new FileReader();
        reader.onload = async () => {
          this.operacao.logo = reader.result.split(",")[1];
          await this.atualizarOperacao();
        };
        reader.readAsDataURL(this.logoFileValido);
      } else {
        this.atualizarOperacao();
      }
    },

    mostrarSnackbar(text, color = "success") {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.show = true;
    }
  }
};
</script>

<style scoped>
.card-section {
  border: 1px solid #E0E0E0;
  border-radius: 10px;
}

.section-title {
  font-size: 15px;
  font-weight: 700;
  color: #333;
  padding-bottom: 8px;
}

.info-label {
  font-size: 11px;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

.info-value {
  font-size: 14px;
  color: #333;
  margin-bottom: 12px;
}

.instrucoes-box {
  background-color: #F5F5F5;
  border-radius: 8px;
  padding: 12px 16px;
  border-left: 3px solid #1976D2;
}

.instrucao-item {
  font-size: 13px;
  color: #555;
  line-height: 1.8;
}

.logo-preview-area {
  width: 180px;
  height: 180px;
  border: 2px dashed #E0E0E0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FAFAFA;
  overflow: hidden;
}

.logo-preview-img {
  width: 180px;
  height: 180px;
}

.logo-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.error-text {
  color: #d32f2f;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 4px;
}
@media (max-width: 600px) {
  .d-flex.justify-space-between.align-center {
    flex-wrap: wrap;
  }

  .btn-salvar {
    width: 100%;
    min-width: unset;
    margin-top: 12px;
  }
}
.link-status-maquinas {
  color: #1976D2;
  text-decoration: underline;
  font-size: 14px;
  cursor: pointer;
  word-break: break-all;
}
</style>